import { useRegistry } from '@/hooks/useRegistry'
import { formatEventTimeRange, isFullDayEvent } from '@/lib/formatEventTime'
import { useMemo, type JSX } from 'react'
import { useTranslation } from 'react-i18next'

export const Time = ({ startTime, endTime, dateGranularity }: {
  startTime?: Date | string
  endTime?: Date | string
  dateGranularity?: string
}): JSX.Element => {
  const { locale, timeZone } = useRegistry()
  const { t } = useTranslation('core')

  return useMemo(() => {
    if (!startTime || !endTime) {
      return <></>
    }

    const start = typeof startTime === 'object' ? startTime : new Date(startTime)
    const end = typeof endTime === 'object' ? endTime : new Date(endTime)

    const formattedTime = isFullDayEvent(dateGranularity)
      ? t('timeSlots.fullday')
      : formatEventTimeRange(start, end, locale.code.full, timeZone)

    return (
      <div className='font-medium text-sm'>{formattedTime}</div>
    )
  }, [locale, timeZone, startTime, endTime, dateGranularity, t])
}
